<template>
  <div>
    <header
      id="bar-top"
      class="fixed-top bg-light w-100 p-0"
      role="grid">
      <div id="banner"
        class="w-100 d-flex justify-content-between align-items-end">
        <b-button variant="outline-light mb-3" v-b-toggle.sidebar-no-header><span class="navbar-toggler-icon"></span></b-button>
        <b-sidebar id="sidebar-no-header" aria-labelledby="sidebar-no-header-title" no-header shadow>
          <template
            #default="{ hide }">
            <div class="p-3">
              <nav class="mb-3">
                <b-nav vertical>
                  <b-nav-item active @click="hide">Active</b-nav-item>
                  <b-nav-item href="#link-1" @click="hide">Link</b-nav-item>
                  <b-nav-item href="#link-2" @click="hide">Another Link</b-nav-item>
                </b-nav>
              </nav>
              <b-button variant="primary" block @click="hide">Close Sidebar</b-button>
            </div>
          </template>
        </b-sidebar>
        <div
          class="d-flex"
          role="grid">
          <img
            class="logo"
            id="logoMonCompte"
            src="../../assets/images/bt-espace-client.svg"
            alt="logo mon compte">
          <img
            class="logo"
            id="logoSearch"
            src="../../assets/images/bt-espace-client.svg"
            alt="logo mon compte">
          <img
            class="logo"
            id="logoDeco"
            src="../../assets/images/bt-espace-client.svg"
            alt="logo mon compte">
        </div>
        <div
        class="d-flex align-self-stretch py-3">
          <router-link
          :to="{ name: 'Achat'}"
          class="border-right border-dark pr-3">
            <figure class="figure d-flex flex-column justify-content-between h-100 m-0">
              <img
                id="bannerTolusImmo"
                src="../../assets/images/logo-tolusimmo.svg"
                alt="bannière Tolus Immo">
                <figcaption class="figure-caption text-center text-dark">
                  <a
                    href="tel:+33561862927"
                    class="d-block text-dark font-weight-bold mb-0">
                    05 61 86 29 27
                  </a>
                </figcaption>
            </figure>
          </router-link>
          <router-link
            :to="{ name: 'Financement'}"
            class="pl-3">
            <figure class="figure h-100 d-flex flex-column justify-content-between m-0">
              <img id="bannerCGCourtage"
                src="../../assets/images/logo-CGcourtage.svg"
                alt="bannière CG Courtage">
                <figcaption class="figure-caption text-center text-dark">
                  <a
                    href="tel:+33561862263"
                    class="d-block text-dark font-weight-bold mb-0">
                    05 61 86 22 63
                  </a>
                </figcaption>
            </figure>
          </router-link>
        </div>
      </div>
      <div id="barEmail" class="bar w-100 bg-dark"></div>
    </header>
    <main class="row w-100 h-100 m-0 main-row d-flex"
          role="grid">
      <div class="bg-gray col-12">
        <ul id="timeLineBar" class="row center align-items-center list-unstyled border-bottom border-secondary m-0 my-3 w-100">
          <li>
            <router-link
              class="text-dark"
              :to="{ name: 'Home' }">
              Accueil
            </router-link>
          </li>
          <li>
            <p class="openSans-bold mb-0">
              Mon compte
            </p>
          </li>
        </ul>
        <div class="row center justify-content-between">
          <div id="phylactereBienvenue" class="phylactere col-12 col-sm-6 bg-dark-gray p-5">
            <h3 class="text-light">Bienvenue sur votre compte personnel</h3>
            <h1 class="openSans-light text-light">{{ user.prenom }} {{ user.nom }}</h1>
          </div>
            <div class="col-12 col-sm-6 mt-4 mt-sm-0 position-relative px-0">
              <div id="notifications" class="phylactere row p-3">
                <h4 class="openSans-bold col-12 text-uppercase border-bottom border-dark">Mes alertes</h4>
                <div id="alertes" class="col-12 overflow-auto">
                  <b-alert
                  class="alerte border-bottom border-dark mb-3"
                  variant="dark"
                  v-for="(notification, idx) in notifications"
                  :key="idx"
                  show
                  dismissible>
                    <p class="m-0">{{ notification.intitule }}</p>
                    <router-link :to="{ name:'Home' }" class="d-block text-dark openSans-bold">Consulter</router-link>
                    <small class="d-block text-muted">{{ notification.date | moment("from", "now") }}</small>
                  </b-alert>
                </div>
              </div>
              <div id="help" class="row bg-dark p-3">
                <h3 class="text-light mb-4">Besoin d'aide ou de conseils</h3>
                <b-button
                id="contactProfil"
                squared
                variant="light text-uppercase">
                  Contacter
                </b-button>
              </div>
            </div>
        </div>
      </div>
      <div class="col-12 py-4">
        <div
        id="secondRow"
        class="row center">
          <div id="profil" class="col-12 col-md-3">
            <img :src="user.photo" alt="Mon image de profil">
            <h4 class="text-grey text-uppercase">Mon Profil</h4>
            <p>Ma date de naissance : {{ user.dateNaissance }}</p>
            <p>Mon adresse : {{ user.adresse }}, {{ user.codePostal }} {{ user.ville }}</p>
            <p>Mon email : {{ user.email }}</p>
            <p>Mon téléphone : {{ user.telephone }}</p>
            <b-button
            squared
            variant="dark text-uppercase">
              Consulter ou Modifier
            </b-button>
          </div>
          <div class="col-12 col-md-9">
            <h4 class="row openSans-bold text-dark">mes démarches EN COURS</h4>
            <div id="demarches" class="row overflow-auto">
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Vue from 'vue'
import DataApi from 'fm-data-api'
import { SidebarPlugin } from 'bootstrap-vue'

Vue.use(SidebarPlugin)
const moment = require('moment')
require('moment/locale/fr')

Vue.use(require('vue-moment'), {
  moment
})

export default {
  name: 'Compte',
  data () {
    return {
      user: {},
      produits: {},
      notifications: {}
    }
  },
  methods: {
    async loadUser () {
      const options = {
        apiUrl: this.$apiUrl,
        databaseName: this.$databaseName,
        token: await this.$getMainToken()
      }
      const dataApi = new DataApi(options)
      const scripts = [{
        name: 'chercheCompte',
        type: 'prerequest'
      }]
      dataApi.getRecords('W_Utilisateur', '', '', '', [], scripts)
        .then((response) => {
          this.user = Vue.removeLayout(response[0].fieldData)
          const dataProduits = {}
          let i = 0
          Object.values(response[0].portalData.acc_uti_sou_PRD__Produit).forEach((produit) => {
            dataProduits[i] = Vue.removeLayout(produit)
            i++
          })
          this.produits = dataProduits
          const dataNotifs = {}
          i = 0
          Object.values(response[0].portalData.acc_uti_prd_NOT__Notification).forEach((notif) => {
            dataNotifs[i] = Vue.removeLayout(notif)
            i++
          })
          this.notifications = dataNotifs
        })
    }
  },
  created () {
    if (Vue.prototype.$isLogged === false) {
      this.$router.push({ name: 'Connexion' })
    } else {
      this.loadUser()
    }
  }
}
</script>

<style lang="scss" scoped>
$heigtBarTop: 11.8rem;
$heightNavBar: 3rem;

$widthNotifs: 21rem;
$heightNotifs: 29.5rem;

main {
  padding: $heigtBarTop 0 0 0 !important;
}

.logo {
  width:9.6rem !important;
}

#bar-top {
  height: $heigtBarTop !important;
  #barEmail {
    height: $heightNavBar !important;
  }
  #banner {
    height: calc(#{$heigtBarTop} - #{$heightNavBar});
  }
}

#banner{
  .custom-toggler {
    border-color: var(--secondary) !important;
  }
  .navbar-toggler-icon {
    width: 2.2rem !important;
    background-size: cover !important;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28227, 13, 104, 1%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
  }
}

#bannerTolusImmo {
  width: 11.5rem !important;
}

#bannerCGCourtage {
  width: 11.8rem !important;
}

.bg-gray {
  background-color: #E1E1E1A6 !important;
}

#timeLineBar {
  li:not(:last-of-type)::after {
    content: '>';
    padding: 0 1rem !important;
    color: var(--secondary);
  }
}

.phylactere {
  border-radius: 2.8rem 2.8rem 2.8rem 0 !important;
}

#phylactereBienvenue.bg-dark-gray {
  background-color: #5b5b5b !important;
}

#notifications {
  background-color: #DCDBDB !important;
  margin: 0 !important;
  height: $heightNotifs !important;
  h4 {
    height: 2rem !important;
  }
  #alertes {
    height: calc(100% - 4rem) !important;
  }
}
#help {
  margin: 1rem auto !important;
  border-radius: 0 2.8rem 2.8rem 2.8rem !important;
  width: 100% !important;
}

::v-deep .alert-dismissible .close {
  transform: translateY(-50%) !important;
  top: 50% !important;
}

#contactProfil {
  width: calc(100% - 2rem) !important;
  margin: 0 1rem !important;
  background-color: #E1E1E1 !important;
}

@media (min-width: 576px) {
  #notifications {
    position: absolute;
    right: 0;
    max-width: $widthNotifs !important;
  }
  #help {
    position: absolute !important;
    right: 0 !important;
    top: $heightNotifs !important;
    max-width: $widthNotifs !important;
  }
  #secondRow {
    padding-right: $widthNotifs !important;
  }
}
</style>
